{
  "characters_remaining": "{number} characters remaining",
  "characters_required": "{number} more characters required",
  "close": "Close",
  "dismiss": "Dismiss",
  "loading": "Loading...",
  "opens_new_tab": "(opens in a new tab)",
  "remove_item": "Remove \"{name}\"",
  "toggle_card_body": "Toggle card body",
  "loading_spinner": "Loading spinner",
  "previous_page": "Previous page",
  "next_page": "Next page",
  "first_page": "First page",
  "last_page": "Last page",
  "go_to_page": "Go to page",
  "remove_option": "Remove {option}",
  "checklist_progress": "{completed} of {total} complete",
  "clear_selection": "Clear selection",
  "toggle_selection": "Toggle selection",
  "tabs": "Tabs"
}
